import { render } from "./DownloadMonitoring.vue?vue&type=template&id=aefc33e6&scoped=true"
import script from "./DownloadMonitoring.vue?vue&type=script&lang=js"
export * from "./DownloadMonitoring.vue?vue&type=script&lang=js"

import "./DownloadMonitoring.vue?vue&type=style&index=0&id=aefc33e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aefc33e6"]])

export default __exports__